module.exports = __webpack_public_path__ + "assets/04b2f3c4c19f980beb767d444fc43698.png";